var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#4B7670"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7221 9.4375H30.3057L22.4765 18.3858L31.687 30.5625H24.4742L18.8257 23.1774L12.3625 30.5625H8.77666L17.1508 20.9913L8.31625 9.4375H15.71L20.8157 16.1878L26.7221 9.4375ZM25.4643 28.4175H27.4501L14.6321 11.4698H12.5012L25.4643 28.4175Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXLogo);
export default __webpack_public_path__ + "static/media/x-logo.fc70d77cd0e200bf4eec5d8c43b819a2.svg";
export { ForwardRef as ReactComponent };